($ => {
  Drupal.behaviors.lazyload = {
    attach(context) {
      $(context)
        .find('[data-bgimage]')
        .each((index, element) => {
          const $element = $(element);
          const url = $element.data('bgimage');

          $element.css('background-image', `url(${url})`);
          $element.removeAttr('data-bgimage');
          $element.removeData('bgimage');
        });

      $(context)
        .find('[data-image-src]')
        .each((index, element) => {
          const $element = $(element);
          const url = $element.data('image-src');

          $element.attr('src', url);
          $element.removeAttr('data-image-src');
          $element.removeData('image-src');
        });
    },
  };
})(jQuery);
